import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Flex } from '@abyss/web/ui/Flex';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Popover } from '@abyss/web/ui/Popover';
import { Text } from '@abyss/web/ui/Text';
import find from 'lodash/find';
import React, { useState } from 'react';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { phoneOnly } from '../ConstantsStyles';
import {
  distanceInfoIcon,
  distancePopover,
  drawerStyle,
} from '../RadioGroup/DistanceInfoIcon.styled';
import { planTypeDisabledInfoIconText } from './PlanTypeDisabledInfoIcon.styled';

export const PlanTypeDisabledInfoIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const mobileScreen = useMediaQuery(phoneOnly);
  const uiMessaging = useLagoon('ui-messaging')();
  const planTypeInfoIconContent = find(uiMessaging, {
    key: ConstantsLagoon.CONTENT_FILTERS.PLAN_TYPE_DISABLED_INFO_ICON,
  });
  const planTypeInfoText = find(uiMessaging, {
    key: ConstantsLagoon.CONTENT_FILTERS.PLAN_TYPE_DISABLED_INFO_TEXT,
  });
  const content = () => (
    <Flex
      css={{
        'abyss-flex-root': {
          padding: '16px 0px 0px 0px',
        },
      }}
      data-testid="plan-type-disabled-info-icon-popover"
      onClick={() => setIsOpen(true)}
    >
      <IconMaterial
        css={distanceInfoIcon}
        icon="info"
        size={24}
        variant="outlined"
      />
      <Text
        css={planTypeDisabledInfoIconText}
        data-testid="plan-type-disabled-info-text"
      >
        {planTypeInfoText?.title}
      </Text>
    </Flex>
  );

  return (
    <React.Fragment>
      {!mobileScreen ? (
        <Popover
          content={planTypeInfoIconContent?.message}
          css={distancePopover}
          data-testid="plan-type-disabled-info-icon-popover"
          onOpenChange={() => {
            setIsOpen(!isOpen);
          }}
          open={isOpen}
          title={planTypeInfoIconContent?.title}
          width={220}
        >
          {content()}
        </Popover>
      ) : (
        <React.Fragment>
          {content()}
          <Drawer
            css={drawerStyle}
            data-auto-testid="plan-type-disabled-info-icon-popover"
            data-testid="plan-type-disabled-info-icon-popover"
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            position="bottom"
            title={planTypeInfoIconContent?.title}
            titleAlign="left"
          >
            <Drawer.Section>{planTypeInfoIconContent?.message}</Drawer.Section>
          </Drawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
